import { render, staticRenderFns } from "./PsiQuickLinks.vue?vue&type=template&id=3879f1ac&scoped=true&"
import script from "./PsiQuickLinks.vue?vue&type=script&lang=js&"
export * from "./PsiQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./PsiQuickLinks.vue?vue&type=style&index=0&id=3879f1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879f1ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItem,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3879f1ac')) {
      api.createRecord('3879f1ac', component.options)
    } else {
      api.reload('3879f1ac', component.options)
    }
    module.hot.accept("./PsiQuickLinks.vue?vue&type=template&id=3879f1ac&scoped=true&", function () {
      api.rerender('3879f1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/menus/PsiQuickLinks.vue"
export default component.exports